import { tOf, valueInfoOf } from '@dirootie-extensions/javascript';

import _ from 'lodash';

const isString = _.isString;
const isNumber = _.isNumber;
const isObject = _.isObject;
const isFunction = _.isFunction;
const isBoolean = _.isBoolean;
const isError = (val: any) => _.isError(val) && val instanceof Error;
const isUndefined = _.isUndefined;
const isNull = _.isNull;

export type AssertionUtils = {
  tOf: typeof tOf;
  valueInfoOf: typeof valueInfoOf;
  isString: typeof isString;
  isNumber: typeof isNumber;
  isObject: typeof isObject;
  isFunction: typeof isFunction;
  isBoolean: typeof isBoolean;
  isError: typeof isError;
  isUndefined: typeof isUndefined;
  isNull: typeof isNull;
};

const internalAssertionUtils = (): AssertionUtils => {
  return {
    tOf,
    valueInfoOf,
    isString,
    isNumber,
    isObject,
    isFunction,
    isBoolean,
    isError,
    isUndefined,
    isNull,
  };
};
export const assertionUtils = internalAssertionUtils();
